<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 20L16.1596 16.1192M16.1596 16.1192C17.4346 14.834 18.2222 13.0645 18.2222 11.1111C18.2222 7.18375 15.0385 4 11.1111 4C7.18375 4 4 7.18375 4 11.1111C4 15.0385 7.18375 18.2222 11.1111 18.2222C13.0851 18.2222 14.8711 17.4179 16.1596 16.1192Z" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>